<template>
  <div class="zj-form-container">
    <el-container>
      <zj-layout-main>
        <el-form
          ref="Form"
          :model="data"
          :rules="rules"
          label-width="120px"
          style="width: 90%"
        >
          <el-form-item label="结案说明" prop="FinishDesc">
            <el-input
              v-model="data.FinishDesc"
              type="textarea"
              :autosize="{ minRows: 4 }"
            ></el-input>
          </el-form-item>
        </el-form>
      </zj-layout-main>
      <el-footer style="text-align: center">
        <el-button type="primary" @click="OnConfirm('Form')">确认</el-button>
        <el-button @click="OnCancel">取消</el-button>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";

export default {
  name: "ComplaintFinish",
  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      loadingText: "加载中...",
      rules: {
        FinishDesc: [
          { required: true, message: "请输入结案说明", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    OnConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.UpdateInfo();
        } else {
          return false;
        }
      });
    },
    OnCancel() {
      this.$emit("clickCancel", {});
    },
    UpdateInfo() {
      this.loading = true;
      this.data.FinishUser = ZJApp.ZJUser.current.UserName;
      this.data.FinishTime = new Date();
      this.data.ComplaintStatus = 5;
      let formAll = JSON.stringify(this.data);
      formAll = JSON.parse(formAll);
      new MyApis.TranResourcesApi()
        .UpdateItem(formAll)
        .then((r) => {
          r = r.data.Data;
          this.$message({
            type: "success",
            message: r ? "保存成功！" : "保存失败！",
          });
          this.loading = false;
          this.logInfo.ActionName = "投诉结案";
          this.logInfo.LogMessage = "投诉结案";
          this.logInfo.ModuleName = "投诉系统";
          this.logInfo.PageName = "投诉结案页面";
          this.addOperationLog();
          this.$emit("clickCancel", {});
          this.$router.go(-1); //返回上一层
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
  },
};
</script>

<style></style>
